import script from "./tableButton.vue?vue&type=script&lang=js"
export * from "./tableButton.vue?vue&type=script&lang=js"

import "./tableButton.vue?vue&type=style&index=0&id=47020724&lang=scss&scoped=true"

import exportComponent from "/Volumes/kaifa/ApiJavaAdmin/vn-admin-ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-47020724"]])

export default __exports__